import ExtrachargeIndexVue from "@/views/extracharge/ExtraChargeIndex.vue";

const extracharge = [
  {
    path: "/extracharge",
    name: "extracharge",
    component: ExtrachargeIndexVue,
    meta: {
      layout: "default",
      role: ["superadmin","backoffice","supervisor"],
      public: false,
    },
  },
];

export default extracharge;
